import { createBrowserRouter } from 'react-router';

// project import
import MainRoutes from './MainRoutes.js';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes], {
  basename: import.meta.env.VITE_APP_BASE_NAME
});

export default router;
